import type { BaseIconProps } from "@/assets/icons/geist/utils";
import type { FC } from "react";

export const IconThumbsUp: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_458_1067)">
                        <path
                            d="M5.08333 6.83331V13.8333"
                            stroke="currentColor"
                            strokeWidth="1.15"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M9.75 4.43002L9.16667 6.83335H12.5675C12.7486 6.83335 12.9273 6.87552 13.0893 6.95652C13.2513 7.03752 13.3922 7.15513 13.5008 7.30002C13.6095 7.44492 13.683 7.61312 13.7154 7.79132C13.7478 7.96952 13.7382 8.15281 13.6875 8.32669L12.3283 12.9934C12.2577 13.2357 12.1103 13.4486 11.9083 13.6C11.7064 13.7515 11.4608 13.8334 11.2083 13.8334H3.33334C3.02392 13.8334 2.72717 13.7104 2.50838 13.4916C2.28959 13.2729 2.16667 12.9761 2.16667 12.6667V8.00002C2.16667 7.6906 2.28959 7.39386 2.50838 7.17506C2.72717 6.95627 3.02392 6.83335 3.33334 6.83335H4.94334C5.16039 6.83324 5.3731 6.77258 5.55756 6.65819C5.74202 6.5438 5.89092 6.38023 5.98751 6.18585L8 2.16669C8.27509 2.17009 8.54585 2.23562 8.79206 2.35837C9.03826 2.48112 9.25355 2.65792 9.42182 2.87556C9.5901 3.09319 9.70702 3.34605 9.76385 3.61522C9.82068 3.8844 9.81595 4.16293 9.75 4.43002Z"
                            stroke="currentColor"
                            strokeWidth="1.15"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_458_1067">
                            <rect width="14" height="14" fill="white" transform="translate(1 1)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_458_1072)">
                        <path
                            d="M6.66667 8.66669V16.6667"
                            stroke="currentColor"
                            strokeWidth="1.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M12 5.91998L11.3333 8.66665H15.22C15.427 8.66665 15.6311 8.71484 15.8163 8.80741C16.0014 8.89998 16.1625 9.03439 16.2867 9.19998C16.4109 9.36557 16.4948 9.55781 16.5318 9.76147C16.5688 9.96512 16.558 10.1746 16.5 10.3733L14.9467 15.7066C14.8659 15.9836 14.6975 16.2269 14.4667 16.4C14.2359 16.5731 13.9552 16.6666 13.6667 16.6666H4.66666C4.31304 16.6666 3.9739 16.5262 3.72385 16.2761C3.4738 16.0261 3.33333 15.6869 3.33333 15.3333V9.99998C3.33333 9.64636 3.4738 9.30722 3.72385 9.05717C3.9739 8.80712 4.31304 8.66665 4.66666 8.66665H6.50666C6.75472 8.66651 6.99782 8.59719 7.20863 8.46646C7.41944 8.33573 7.58961 8.14879 7.7 7.92665L10 3.33331C10.3144 3.33721 10.6238 3.41209 10.9052 3.55238C11.1866 3.69266 11.4326 3.89472 11.6249 4.14345C11.8172 4.39218 11.9509 4.68115 12.0158 4.98878C12.0808 5.29641 12.0754 5.61474 12 5.91998Z"
                            stroke="currentColor"
                            strokeWidth="1.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_458_1072">
                            <rect width="16" height="16" fill="white" transform="translate(2 2)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_458_1077)">
                        <path
                            d="M8.25 10.5V19.5"
                            stroke="currentColor"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M14.25 7.41L13.5 10.5H17.8725C18.1054 10.5 18.335 10.5542 18.5433 10.6584C18.7516 10.7625 18.9328 10.9137 19.0725 11.1C19.2122 11.2863 19.3066 11.5026 19.3483 11.7317C19.39 11.9608 19.3777 12.1964 19.3125 12.42L17.565 18.42C17.4741 18.7316 17.2846 19.0053 17.025 19.2C16.7654 19.3947 16.4496 19.5 16.125 19.5H6C5.60218 19.5 5.22064 19.342 4.93934 19.0607C4.65804 18.7794 4.5 18.3978 4.5 18V12C4.5 11.6022 4.65804 11.2206 4.93934 10.9393C5.22064 10.658 5.60218 10.5 6 10.5H8.07C8.34906 10.4999 8.62255 10.4219 8.85972 10.2748C9.09688 10.1277 9.28832 9.91741 9.4125 9.6675L12 4.5C12.3537 4.50438 12.7018 4.58863 13.0184 4.74645C13.3349 4.90427 13.6117 5.13158 13.8281 5.4114C14.0444 5.69122 14.1947 6.01632 14.2678 6.3624C14.3409 6.70848 14.3348 7.0666 14.25 7.41Z"
                            stroke="currentColor"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_458_1077">
                            <rect width="18" height="18" fill="white" transform="translate(3 3)" />
                        </clipPath>
                    </defs>
                </svg>
            );
    }
};
